import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-create-doc-signature-dialog',
  templateUrl: './create-doc-signature-dialog.component.html',
  styleUrls: ['./create-doc-signature-dialog.component.scss'],
})
export class CreateDocSignatureDialogComponent {
  withSignature = false;

  constructor(private dialogRef: MatDialogRef<CreateDocSignatureDialogComponent>) {}

  selectOption(withSignature: boolean): void {
    this.withSignature = withSignature;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onCreate(): void {
    this.dialogRef.close({ confirmed: true });
  }
}
